import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { MultistoreApi } from "apis/MultistoreApi";
import { MultiStoreChange } from "models/storeModels/MultiStoreGraph";

export const GetMultiStoreStores = createAsyncThunk("multiStoreSlice/getMultiStoreStores", async () => {
    const response = await MultistoreApi.MultiStoreStoreSearch({});
    return response.data;
})

export const GetViewableStores = createAsyncThunk("multiStoreSlice/getViewableStores", async (storeId: number) => {
    const response = await MultistoreApi.GetViewableStores(storeId);
    return response.data;
});

export const UpdateMultiStore = createAsyncThunk("multiStoreSlice/updateMultiStore", async (params: MultiStoreChange) => {
    const response = await MultistoreApi.UpdateMultiStore(params);
    return response.data;
});


export const MultiStoreTest = createAsyncThunk("multiStoreSlice/multiStoreTest", async (storeIds: number[]) => {
    const response = await MultistoreApi.MultiStoreTest(storeIds);
    return response.data;
});

type InitialStateType = {
};

const initialState: InitialStateType = {

};

const multiStoreSlice = createSlice({
    name: "multiStoresSlice",
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
    }
});


export const { } = multiStoreSlice.actions;

export default multiStoreSlice.reducer;